import React, { lazy, Suspense, useState, useRef, useCallback } from "react";
import { SubHeading } from "../../shared/Components";
import CommonModal from "../../shared/Components/Modal/CommonModal";
import { TournamentModal } from "../../shared/Components/Modal";
import TournamentSettings from "../GameSettings/ TournamentSettings";

const TournamentsBody = lazy(() => import("./TournamentsBody"));

const Tournaments = () => {
  const refetchRef = useRef(null);

  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    modalTitle: "",
    modalContent: null,
    modalSize: "md",
  });

  const handleModal = (rowData, title = "", modalSize = "md") => {
    setIsShow({
      isOpen: true,
      modalContent: TournamentModal,
      modalTitle: title,
      rowData,
      modalSize,
    });
  };

  const handleTournamentSetting = useCallback((rowData) => {
    setIsShow({
      isOpen: true,
      modalContent: TournamentSettings,
      modalTitle: "Tournament Settings",
      rowData,
      modalSize: "xxl",
    });
  }, []);

  return (
    <>
      <SubHeading
        isAdd={true}
        handleShowHide={() => handleModal({}, "Create")}
        isBack={true}
      />

      <Suspense fallback={<div>Loading...</div>}>
        <TournamentsBody
          onRefetchReady={(fn) => (refetchRef.current = fn)}
          onTournamentSetting={handleTournamentSetting}
        />
      </Suspense>

      {isShow?.isOpen && (
        <CommonModal
          size={isShow.modalSize}
          isShow={isShow.isOpen}
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              modalSize: "md",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleModalHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  modalTitle: "",
                })),
              rowData: isShow.rowData,
              fetchData: () => refetchRef.current?.(),
            })}
        </CommonModal>
      )}
    </>
  );
};

export default Tournaments;
